import { Navigate } from "react-router-dom";
import { LoginForm } from "../../components/Login"
import { useUser } from "../../hooks/useUser";
import toast from "react-hot-toast";

const Landing = () => {
    const userApi = useUser();
    if (userApi.state === "LoggedIn"){
        return <Navigate to="/home" />
    }
    return (
        <div>
            Welcome to the VNOG Landing Page
            <LoginForm successCallback={() => toast.success("Logged in successfully - Redirecting")} />
        </div>
    )
}

export default Landing;